webpackJsonp([1],{

/***/ "+dqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_vm._m(1),_vm._v(" "),_c('Speech',{on:{"onRecognized":_vm.acceptSentence}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-6"},[_c('AdjectiveFigure')],1)]),_vm._v(" "),_c('Exercise',{attrs:{"acceptSentenceList":_vm.acceptSentenceList},on:{"completed":_vm.openDialog}}),_vm._v(" "),_c('ExerciseResultDialog',{attrs:{"result":_vm.exerciseResult}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron"},[_c('h1',{staticClass:"display-3"},[_c('ruby',[_vm._v("形容詞"),_c('rt',[_vm._v("Adjective")])])]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("形容詞は名詞の形や性質や状態をあらわす単語です")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info text-left",attrs:{"role":"alert"}},[_c('p',[_vm._v("日本語では形容詞の順番は気にしませんが、英語ではだいたいの語順があります")]),_vm._v(" "),_c('blockquote',[_c('p',[_vm._v("表1.の"),_c('span',{staticClass:"text-danger"},[_vm._v("赤字部分")]),_vm._v("をとって*1 "),_c('span',{staticClass:"text-danger"},[_vm._v("OPSHACOM オプシャコム")]),_vm._v("と覚えます")]),_vm._v(" "),_c('cite',[_c('a',{attrs:{"href":"http://www.professorgrammar.com/opshacom2.shtml","target":"grammer"}},[_vm._v("*1 引用元 professorgrammar")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/wxT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5W1q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AnnU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Awz2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_c('h4',{staticClass:"alert-heading"},[_vm._v("練習問題")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"question"},[_c('p',{staticClass:"speech"},_vm._l((_vm.shuffledList),function(elm,idx){return _c('transition',{key:'sp-' + idx,attrs:{"name":"fade","tag":"span"},on:{"before-leave":_vm.beforeLeave,"after-leave":_vm.afterLeave}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(elm.visible),expression:"elm.visible"}],staticClass:"btn btn-raised btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.addWordSelection(elm)}}},[_vm._v(_vm._s(elm.word))])])})),_vm._v(" "),(_vm.completed)?_c('button',{staticClass:"btn btn-lg btn-raised btn-primary",attrs:{"type":"button"},on:{"click":_vm.nextQuestion}},[_c('i',{staticClass:"fa fa-refresh",attrs:{"aria-hidden":"true"}}),_vm._v("次の問題")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"answer"},[_c('p',{staticClass:"sentence"},[_c('button',{staticClass:"btn btn-primary btn-raised ",attrs:{"type":"button","disabled":""}},[_vm._v(_vm._s(_vm.determiner))]),_vm._v(" "),_vm._l((_vm.selectList),function(elm,idx){return _c('button',{key:'ans-adj-' + idx,staticClass:"btn btn-raised btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.removeWordSelection(elm)}}},[_vm._v(_vm._s(elm.word))])}),_vm._v(" "),_vm._l((_vm.countOfPlaceHolder()),function(n,idx){return _c('button',{key:'ans-fake-' + idx,staticClass:"btn btn-warning btn-raised fake",attrs:{"type":"button","disabled":""}},[_vm._v(" ")])}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-raised ",attrs:{"type":"button","disabled":""}},[_vm._v(_vm._s(_vm.noun))])],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i',{staticClass:"fa fa-question-circle",attrs:{"aria-hidden":"true"}}),_vm._v("\n    次の語句を正しい順番に並べ替えなさい\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F/L/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExerciseResultDialog_vue__ = __webpack_require__("eN+F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fcabfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExerciseResultDialog_vue__ = __webpack_require__("drEr");
function injectStyle (ssrContext) {
  __webpack_require__("pe4A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06fcabfa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExerciseResultDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06fcabfa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExerciseResultDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GWyp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hn6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__speech__ = __webpack_require__("WTV1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: '形容詞',
      useSpeechRecognition: false,
      voiceShotName: '',
      voiceOptions: [],
      status: '停止状態',
      availableRecognition: false,
      said_list: []
    };
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getAsyncVoices(function (list) {
      self.availableRecognition = __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getInstance().isAvailableRecognition();
      if (!self.availableRecognition) {
        self.status = '当ブラウザでは音声認識をご利用できません。Chromeブラウザをご利用ください';
      }
      if (list) {
        self.voiceOptions.splice(0, self.voiceOptions.length);
        self.voiceShotName = null;
        for (var i = 0; i < list.length; i++) {
          self.voiceOptions.push(list[i]);
        }
        var voice = __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getFirstVoice('en-');
        if (voice === null) {
          voice = self.voiceOptions[0];
        }
        if (voice) {
          self.voiceShotName = __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getShortVoiceName(voice.name, voice.lang);
          __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getInstance().resetVoice(self.voiceShotName);
        }
      }
    });
  },
  methods: {
    getShortVoiceName: function getShortVoiceName(name, lang) {
      return __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getShortVoiceName(name, lang);
    },
    resetVoice: function resetVoice() {
      __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getInstance().resetVoice(this.voiceShotName);
    },
    toggleRecognition: function toggleRecognition() {
      var self = this;
      if (this.useSpeechRecognition) {
        self.status = '認識中。正しい語順で発音してください。';
        __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getInstance().start(function (result) {
          if (result.status === 'end') {
            self.status = '停止状態';
            self.useSpeechRecognition = false;
          } else if (result.status === 'error') {
            self.status = 'エラー状態';
            self.useSpeechRecognition = false;
          } else {
            var sentendList = [];
            self.status = '認識成功';
            self.said_list.splice(0, self.said_list.length);
            result.said_list.forEach(function (s) {
              self.said_list.push({
                confidence: '[' + (100 * s.confidence).toFixed(2) + '%]',
                sentence: s.transcript
              });
              sentendList.push(s.transcript);
            });
            self.$emit('onRecognized', sentendList);
          }
        });
      } else {
        self.status = '停止状態';
        __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getInstance().stop();
      }
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01426e5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Rx4+");
function injectStyle (ssrContext) {
  __webpack_require__("SaN3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01426e5b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MaQw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Speech__ = __webpack_require__("P2MH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AdjectiveFigure__ = __webpack_require__("OSgq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Exercise__ = __webpack_require__("cBMh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExerciseResultDialog__ = __webpack_require__("F/L/");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Speech: __WEBPACK_IMPORTED_MODULE_0__Speech__["a" /* default */],
    AdjectiveFigure: __WEBPACK_IMPORTED_MODULE_1__AdjectiveFigure__["default"],
    Exercise: __WEBPACK_IMPORTED_MODULE_2__Exercise__["a" /* default */],
    ExerciseResultDialog: __WEBPACK_IMPORTED_MODULE_3__ExerciseResultDialog__["a" /* default */]
  },
  data: function data() {
    return {
      msg: '形容詞',
      acceptSentenceList: [],
      exerciseResult: {
        isCorrect: false,
        correctWords: [],
        yourWords: [],
        correctSentence: '',
        noun: ''
      }
    };
  },
  methods: {
    openDialog: function openDialog(result) {
      this.exerciseResult = result;
      $('#exercise-result-dialog').modal('toggle');
    },
    acceptSentence: function acceptSentence(saidList) {
      this.acceptSentenceList = saidList;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OPwT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Adjective_vue__ = __webpack_require__("MaQw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed29dad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Adjective_vue__ = __webpack_require__("+dqs");
function injectStyle (ssrContext) {
  __webpack_require__("GWyp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ed29dad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Adjective_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed29dad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Adjective_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OSgq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdjectiveFigure_vue__ = __webpack_require__("tFvT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdjectiveFigure_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdjectiveFigure_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b74c3c44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdjectiveFigure_vue__ = __webpack_require__("lTXf");
function injectStyle (ssrContext) {
  __webpack_require__("rcw5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b74c3c44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdjectiveFigure_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b74c3c44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdjectiveFigure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "P2MH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Speech_vue__ = __webpack_require__("Hn6e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b5a5162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Speech_vue__ = __webpack_require__("am3q");
function injectStyle (ssrContext) {
  __webpack_require__("AnnU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b5a5162"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Speech_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b5a5162_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Speech_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rx4+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SaN3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WTV1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__QuestionGenerator__ = __webpack_require__("tUJL");




var sleep = __webpack_require__("/yzD")();
var log = __webpack_require__("BvyM");
log.setLevel('info');
var single = null;

function createRecognitionResult(rs) {
  var result = {
    status: 'success',
    said_list: []
  };
  for (var i = 0; i < rs.length; i++) {
    for (var j = 0; j < rs[i].length; j++) {
      result.said_list.push(rs[i][j]);
    }
  }

  return result;
}

var SpeechUtil = function () {
  function SpeechUtil(lang) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SpeechUtil);

    var self = this;
    this.voice = SpeechUtil.getFirstVoice(lang);
    this.rec = null;
    this.isRunnningRecognition = false;
    this.isLoopRequired = false;
    this.numOfEndRecognitionResult = 0;
    this.callbackOnRecognitionResult = null;
    var SpRec = null;
    var SpGrm = null;

    //    var SpREv = null

    if (typeof SpeechRecognition !== 'undefined') {
      SpRec = SpeechRecognition;
      SpGrm = SpeechGrammarList;
      //    SpREv = SpeechRecognitionEvent
    } else if (typeof webkitSpeechRecognition !== 'undefined') {
      SpRec = webkitSpeechRecognition;
      SpGrm = webkitSpeechGrammarList;
      //    SpREv = webkitSpeechRecognitionEvent
    } else if (typeof msSpeechRecognition !== 'undefined') {
      SpRec = msSpeechRecognition;
      SpGrm = msSpeechGrammarList;
      //    SpREv = msSpeechRecognitionEvent
    } else if (typeof mozSpeechRecognition !== 'undefined') {
      SpRec = mozSpeechRecognition;
      SpGrm = mozSpeechGrammarList;
      //    SpREv = mozSpeechRecognitionEvent
    }
    var words = __WEBPACK_IMPORTED_MODULE_2__QuestionGenerator__["a" /* default */].getWords();
    var grammar = '#JSGF V1.0; grammar words; public <words> = ' + words.join(' | ') + ' ;';
    try {
      this.rec = new SpRec();
      var speechRecognitionList = new SpGrm();
      speechRecognitionList.addFromString(grammar, 1);
      this.rec.grammars = speechRecognitionList;
      this.rec.continuous = false;
      this.rec.lang = 'en-US';
      this.rec.interimResults = false;
      this.rec.maxAlternatives = 3;
    } catch (e) {
      log.error('SpeechRecognition is not defined. ', e);
      this.rec = {};
    }

    this.rec.onresult = function (event) {
      this.hasRecognitionResult = true;
      var rs = event.results;
      if (self.callbackOnRecognitionResult) {
        self.callbackOnRecognitionResult(createRecognitionResult(rs));
      }
    };
    this.rec.onend = function (event) {
      self.isRunnningRecognition = false;
      self.numOfEndRecognitionResult++;
      log.info('end...', self.isLoopRequired);
      if (self.isLoopRequired && self.numOfEndRecognitionResult < 100) {
        self.isRunnningRecognition = true;
        self.rec.start();
      } else {
        if (self.callbackOnRecognitionResult) {
          self.callbackOnRecognitionResult({
            status: 'end'
          });
        }
      }
    };
    this.rec.onerr = function (event) {
      if (self.callbackOnRecognitionResult) {
        self.callbackOnRecognitionResult({
          status: 'error'
        });
      }
    };
    this.rec.onstart = function (event) {
      self.numOfEndRecognitionResult = 0;
      self.isRunnningRecognition = true;
      log.info('start...');
    };
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SpeechUtil, [{
    key: 'stop',
    value: function stop() {
      this.rec.stop();
      this.isLoopRequired = false;
    }
  }, {
    key: 'start',
    value: function start(callback) {
      if (this.isAvailableRecognition()) {
        this.isLoopRequired = true;
        this.rec.start();
        this.callbackOnRecognitionResult = callback;
      } else {
        callback({
          status: 'error'
        });
      }
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      if (this.isRunnningRecognition) {
        this.stop();
      } else {
        this.start();
      }
    }
  }, {
    key: 'isAvailableRecognition',
    value: function isAvailableRecognition() {
      return this.rec && this.rec.start;
    }
  }, {
    key: 'speak',
    value: function speak(msg) {
      if (this.voice) {
        var utterThis = new SpeechSynthesisUtterance(msg);
        utterThis.voice = this.voice;
        window.speechSynthesis.speak(utterThis);
      }
    }
  }, {
    key: 'resetVoice',
    value: function resetVoice(shortNoiceName) {
      var newVoice = SpeechUtil.getVoiceByShortVoiceName(shortNoiceName);
      this.voice = newVoice;
    }
  }], [{
    key: 'getVoices',
    value: function getVoices() {
      if (!window.speechSynthesis) {
        return [];
      }
      var arr = window.speechSynthesis.getVoices();
      if (arr) {
        return arr;
      }
      return [];
    }
  }, {
    key: 'getAsyncVoices',
    value: function getAsyncVoices(callback) {
      if (!window.speechSynthesis) {
        callback([]);
        return;
      }
      var options = {
        sleep: 1000,
        interval: 300
      };
      sleep.sleepWithCondition(function () {
        var arr = window.speechSynthesis.getVoices();
        return arr.length > 0;
      }, options, function () {
        callback(window.speechSynthesis.getVoices());
      });
    }
  }, {
    key: 'getFirstVoice',
    value: function getFirstVoice(lang) {
      if (!window.speechSynthesis) {
        return null;
      }
      var arr = window.speechSynthesis.getVoices();
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].lang.indexOf(lang) >= 0) {
          return arr[i];
        }
      }
      if (arr.length > 0) {
        return arr[0];
      }
      return null;
    }
  }, {
    key: 'getShortVoiceName',
    value: function getShortVoiceName(name, lang) {
      if (name === 'native' && lang === '') {
        return name + ' (ネイティブ)';
      }
      return name.replace('Google ', '') + ' (' + lang + ')';
    }
  }, {
    key: 'getVoiceByShortVoiceName',
    value: function getVoiceByShortVoiceName(name) {
      var obj = SpeechUtil.getVoices().filter(function (elm) {
        var sn = SpeechUtil.getShortVoiceName(elm.name, elm.lang);
        return sn === name;
      });
      if (obj) {
        return obj[0];
      }
      return null;
    }
  }, {
    key: 'getInstance',
    value: function getInstance() {
      if (single === null) {
        single = new SpeechUtil();
      }
      return single;
    }
  }]);

  return SpeechUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (SpeechUtil);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Adjective__ = __webpack_require__("OPwT");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Adjective',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Adjective__["a" /* default */]
  }]
}));

/***/ }),

/***/ "am3q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"speech"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-8 text-left"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.voiceShotName),expression:"voiceShotName"}],staticClass:"custom-select",attrs:{"id":"reader"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.voiceShotName=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.resetVoice]}},[_vm._l((_vm.voiceOptions),function(option,idx){return _c('option',{key:idx,domProps:{"value":_vm.getShortVoiceName(option.name, option.lang)}},[_vm._v(_vm._s(option.name))])}),_vm._v(" "),_c('option',{attrs:{"value":""}},[_vm._v("読み上げない")])],2)])])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"row"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-8  text-left"},[_c('label',{staticClass:"custom-control custom-checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.useSpeechRecognition),expression:"useSpeechRecognition"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","name":"recognition"},domProps:{"checked":Array.isArray(_vm.useSpeechRecognition)?_vm._i(_vm.useSpeechRecognition,null)>-1:(_vm.useSpeechRecognition)},on:{"change":[function($event){var $$a=_vm.useSpeechRecognition,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.useSpeechRecognition=$$a.concat([$$v]))}else{$$i>-1&&(_vm.useSpeechRecognition=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.useSpeechRecognition=$$c}},_vm.toggleRecognition]}}),_vm._v(" "),_c('span',{staticClass:"custom-control-indicator"}),_vm._v(" "),_c('span',{staticClass:"custom-control-description",class:{ 'text-muted': !_vm.useSpeechRecognition}},[_c('i',{staticClass:"fa fa-microphone",attrs:{"aria-hidden":"true"}}),_vm._v("利用する\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"row result"},[_c('div',{staticClass:"col-4 text-left",class:{ 'text-muted': !_vm.useSpeechRecognition}},[_c('i',{staticClass:"fa fa-commenting-o",attrs:{"aria-hidden":"true"}}),_vm._v("\n          認識状態\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-8  text-left"},[_c('p',{class:{ 'text-muted': !_vm.useSpeechRecognition}},[_vm._v(_vm._s(_vm.status))]),_vm._v(" "),_c('ol',{staticClass:"text-left"},_vm._l((_vm.said_list),function(said,idx2){return _c('li',{key:idx2},[_vm._v(_vm._s(said.confidence)+" : "+_vm._s(said.sentence))])})),_vm._v(" "),(_vm.availableRecognition)?_c('p',{class:{ 'text-muted': !_vm.useSpeechRecognition}},[_vm._v("問題を変更する場合は「Next Question!」と喋って下さい")]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 text-left"},[_c('i',{staticClass:"fa fa-volume-up",attrs:{"aria-hidden":"true"}}),_vm._v("\n          読上音声選択\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 text-left"},[_c('i',{staticClass:"fa fa-lightbulb-o",attrs:{"aria-hidden":"true"}}),_vm._v("\n          音声認識\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cBMh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exercise_vue__ = __webpack_require__("r3+u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14da2e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Exercise_vue__ = __webpack_require__("Awz2");
function injectStyle (ssrContext) {
  __webpack_require__("/wxT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14da2e32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exercise_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14da2e32_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Exercise_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dEMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Question; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var Question = function () {
  function Question(determiner, opinion, size, shape, age, color, origin, material, noun) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Question);

    this.determiner = determiner;
    this.adjectiveList = [];
    this.selectList = [];
    if (opinion) {
      this.adjectiveList.push({ visible: true, category: 'opinion', word: opinion });
    }
    if (size) {
      this.adjectiveList.push({ visible: true, category: 'size', word: size });
    }
    if (shape) {
      this.adjectiveList.push({ visible: true, category: 'shape', word: shape });
    }
    if (age) {
      this.adjectiveList.push({ visible: true, category: 'age', word: age });
    }
    if (color) {
      this.adjectiveList.push({ visible: true, category: 'color', word: color });
    }
    if (origin) {
      this.adjectiveList.push({ visible: true, category: 'origin', word: origin });
    }
    if (material) {
      this.adjectiveList.push({ visible: true, category: 'material', word: material });
    }
    this.shuffledList = Question.shuffle(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.adjectiveList)));
    this.noun = noun;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Question, null, [{
    key: 'shuffle',
    value: function shuffle(array) {
      var n = array.length;
      var t = void 0;
      var i = void 0;

      while (n) {
        i = Math.floor(Math.random() * n--);
        t = array[n];
        array[n] = array[i];
        array[i] = t;
      }

      return array;
    }
  }]);

  return Question;
}();

/***/ }),

/***/ "drEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade in",attrs:{"tabindex":"-1","id":"exercise-result-dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h1',{staticClass:"modal-title"},[(_vm.result.isCorrect)?_c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-circle-o",attrs:{"aria-hidden":"true"}}),_vm._v("正解")]):_vm._e(),_vm._v(" "),(!_vm.result.isCorrect)?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}}),_vm._v("不正解")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('section',{staticClass:"correct answer "},[_c('h3',{staticClass:"text-success"},[_vm._v("正しい回答\n            "),_c('button',{staticClass:"btn btn-raised btn-default",attrs:{"type":"button"},on:{"click":_vm.playCorrectAnswer}},[_vm._v("再生")])]),_vm._v(" "),_c('p',{staticClass:"correct answer"},[_c('ruby',[_vm._v("\n              "+_vm._s(_vm.result.determiner + ' ')+"\n              "),_c('rt',[_vm._v("Determiner")])]),_vm._v(" "),_vm._l((_vm.result.correctWords),function(w,idx){return _c('ruby',{key:idx},[_vm._v("\n              "+_vm._s(w.word + ' ')+"\n              "),_c('rt',[_vm._v(_vm._s(w.category))])])}),_vm._v(" "),_c('ruby',[_vm._v("\n              "+_vm._s(_vm.result.noun + '.')+"\n              "),_c('rt',[_vm._v("Noun")])])],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"your answer"},[_c('h3',[_vm._v("あなたの回答\n            "),_c('button',{staticClass:"btn btn-raised btn-default",attrs:{"type":"button"},on:{"click":_vm.playYourAnswer}},[_vm._v("再生")])]),_vm._v(" "),_c('p',{staticClass:"your answer"},[_c('span',[_vm._v(_vm._s(_vm.result.determiner + ' '))]),_vm._v(" "),_vm._l((_vm.result.yourWords),function(w,idx2){return _c('span',{key:idx2,class:{ 'text-danger': w.wrong }},[_vm._v(_vm._s(w.word + ' '))])}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.result.noun)+".")])],2)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.close}},[_c('span',{staticClass:"glyphicon glyphicon-remove"}),_vm._v(" "),_c('span',{attrs:{"data-i18n":"common.close"}},[_vm._v("Close")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eN+F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__speech__ = __webpack_require__("WTV1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    result: {
      isCorrect: {
        type: Boolean
      },
      correctSentence: {
        type: String
      },
      correctWords: {
        type: Array,
        default: []
      },
      yourWords: {
        type: Array,
        default: []
      },
      noun: {
        type: String
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    close: function close() {
      this.$emit('close', {});
    },
    playYourAnswer: function playYourAnswer() {
      var sentence = '';
      this.result.yourWords.forEach(function (w) {
        sentence += w.word + ' ';
      });
      sentence += this.result.noun + '.';
      __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getInstance().speak(sentence);
    },
    playCorrectAnswer: function playCorrectAnswer() {
      __WEBPACK_IMPORTED_MODULE_0__speech__["a" /* default */].getInstance().speak(this.result.correctSentence);
    }
  }
});

/***/ }),

/***/ "i1v5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lTXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',[_c('figcaption',[_vm._v("表1. 形容詞の語順")]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-bordered table-sm adjective_order"},[_c('thead',[_c('tr',[_c('td',[_vm._v("順番")]),_vm._v(" "),_c('td',[_vm._v("種類")]),_vm._v(" "),_c('td',[_vm._v("例")])]),_vm._v(" "),_c('tr',{staticClass:"Determiner warning"},[_c('td',[_vm._v("-")]),_vm._v(" "),_c('td',[_vm._v("限定詞（determiner）")]),_vm._v(" "),_c('td',[_vm._v("a, my, this, first, seven")])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"Opinion"},[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_vm._v("意見・感想"),_c('span',{staticClass:"hidden-lgsm"},[_vm._v("・評価")]),_vm._v(" （\n          "),_c('span',{staticClass:"prefix text-danger"},[_vm._v("op")]),_vm._v("inion）")]),_vm._v(" "),_c('td',[_vm._v("lovely, beautiful")])]),_vm._v(" "),_c('tr',{staticClass:"Size"},[_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_vm._v("大きさ（\n          "),_c('span',{staticClass:"prefix text-danger"},[_vm._v("s")]),_vm._v("ize）")]),_vm._v(" "),_c('td',[_vm._v("big, small, tall")])]),_vm._v(" "),_c('tr',{staticClass:"Shape"},[_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_vm._v("形（\n          "),_c('span',{staticClass:"prefix text-danger"},[_vm._v("sh")]),_vm._v("ape）")]),_vm._v(" "),_c('td',[_vm._v("triangular, square")])]),_vm._v(" "),_c('tr',{staticClass:"Age"},[_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_vm._v("新しさ・古さ（\n          "),_c('span',{staticClass:"prefix text-danger"},[_vm._v("a")]),_vm._v("ge）")]),_vm._v(" "),_c('td',[_vm._v("young, old, new")])]),_vm._v(" "),_c('tr',{staticClass:"Color"},[_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_vm._v("色（\n          "),_c('span',{staticClass:"prefix text-danger"},[_vm._v("c")]),_vm._v("olor）")]),_vm._v(" "),_c('td',[_vm._v("blue, white, yellow, black")])]),_vm._v(" "),_c('tr',{staticClass:"Origin"},[_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_vm._v("所属（\n          "),_c('span',{staticClass:"prefix text-danger"},[_vm._v("o")]),_vm._v("rigin）")]),_vm._v(" "),_c('td',[_vm._v("Japanese, European"),_c('span',{staticClass:"hidden-lgsm"},[_vm._v(", Buddhist")])])]),_vm._v(" "),_c('tr',{staticClass:"Material"},[_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_vm._v("素材（\n          "),_c('span',{staticClass:"prefix text-danger"},[_vm._v("m")]),_vm._v("aterials）")]),_vm._v(" "),_c('td',[_vm._v("silk, cotton, leather")])])]),_vm._v(" "),_c('tfoot',[_c('tr',{staticClass:"Noun warning"},[_c('td',[_vm._v("-")]),_vm._v(" "),_c('td',[_vm._v("名詞（noun）")]),_vm._v(" "),_c('td',[_vm._v("brush, dog, woman")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pe4A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r3+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuestionGenerator__ = __webpack_require__("tUJL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__speech__ = __webpack_require__("WTV1");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function createCompleteMessage(result) {
  var ret = {
    isCorrect: true,
    correctWords: [],
    yourWords: [],
    correctSentence: '',
    determiner: '',
    noun: ''
  };
  if (result.determiner) {
    ret.determiner = result.determiner;
    ret.correctSentence = result.determiner + ' ';
  }
  result.selectList.forEach(function (elm, idx) {
    var correctElm = result.adjectiveList[idx];
    var o = {
      word: elm.word,
      wrong: false
    };
    if (elm.word !== correctElm.word) {
      ret.isCorrect = false;
      o.wrong = true;
    }
    ret.yourWords.push(o);
  });
  result.adjectiveList.forEach(function (elm, idx) {
    ret.correctWords.push({
      word: elm.word,
      category: elm.category
    });
    ret.correctSentence += elm.word + ' ';
  });
  ret.correctSentence += result.noun + '.';
  ret.noun = result.noun;
  return ret;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  props: {
    acceptSentenceList: {
      type: Array,
      default: []
    }
  },
  data: function data() {
    var d = __WEBPACK_IMPORTED_MODULE_1__QuestionGenerator__["a" /* default */].create();
    d.completed = false;
    return d;
  },
  methods: {
    countOfPlaceHolder: function countOfPlaceHolder() {
      return this.adjectiveList.length - this.selectList.length;
    },
    addWordSelection: function addWordSelection(obj) {
      for (var i = 0; i < this.shuffledList.length; i++) {
        if (this.shuffledList[i].word === obj.word) {
          // this.shuffled.splice(i, 1)
          // move to afterLeave()
          this.shuffledList[i].visible = false;
        }
      }
      __WEBPACK_IMPORTED_MODULE_2__speech__["a" /* default */].getInstance().speak(obj.word);
    },
    removeWordSelection: function removeWordSelection(obj) {
      this.shuffledList.push(obj);
      for (var i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i].word === obj.word) {
          this.selectList.splice(i, 1);
        }
      }
    },
    nextQuestion: function nextQuestion() {
      var _this = this;

      var nextQuestion = __WEBPACK_IMPORTED_MODULE_1__QuestionGenerator__["a" /* default */].create();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(nextQuestion).forEach(function (name) {
        _this[name] = nextQuestion[name];
      });
      this.completed = false;
    },
    beforeLeave: function beforeLeave(el) {
      Array.prototype.forEach.call(document.querySelectorAll('p.speech > button'), function (elm) {
        elm.setAttribute('disabled', true);
      });
    },
    afterLeave: function afterLeave(el) {
      var selWord = el.innerText.toLowerCase();
      var selObj = this.shuffledList.filter(function (a) {
        return a.word.toLowerCase() === selWord;
      })[0];
      for (var i = 0; i < this.shuffledList.length; i++) {
        if (this.shuffledList[i].word.toLowerCase() === selWord) {
          this.shuffledList[i].visible = true;
          this.shuffledList.splice(i, 1);
          break;
        }
      }
      this.selectList.push(selObj);
      Array.prototype.forEach.call(document.querySelectorAll('p.speech > button'), function (elm) {
        elm.removeAttribute('disabled');
      });
      if (this.shuffledList.length <= 0) {
        var result = createCompleteMessage(this);
        __WEBPACK_IMPORTED_MODULE_2__speech__["a" /* default */].getInstance().speak(result.isCorrect ? 'Correct!' : 'Incorrect!');
        __WEBPACK_IMPORTED_MODULE_2__speech__["a" /* default */].getInstance().speak(result.correctSentence);
        this.completed = true;
        this.$emit('completed', result);
      }
    }
  },
  watch: {
    acceptSentenceList: function acceptSentenceList(newVal, oldVal) {
      var self = this;
      if (newVal && newVal.length > 0) {
        if (newVal.filter(function (sentence) {
          return sentence === 'next question';
        }).length > 0) {
          self.nextQuestion();
        }
        newVal.forEach(function (sentence) {
          sentence.split(' ').forEach(function (word) {
            for (var i = 0; i < self.shuffledList.length; i++) {
              if (self.shuffledList[i].word.toLowerCase() === word.toLowerCase()) {
                self.addWordSelection(self.shuffledList[i]);
              }
            }
          });
        });
      }
    }
  }
});

/***/ }),

/***/ "rcw5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tFvT":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "tUJL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_Question__ = __webpack_require__("dEMD");




var numeral = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
var opinion = ['beautiful', 'unusual', 'lovely', 'excellent', 'wonderful', 'elegant', 'cheap'];
var size = {
  big: ['huge', 'big', 'large', 'enormous'],
  small: ['small', 'little', 'slim', 'enormous']
};
var shape = ['round', 'square', 'rectangular', 'oval', 'flat'];
var age = {
  animal: ['young', 'old', 'baby'],
  object: ['new', 'old']
};
var color = ['black', 'gray', 'blue', 'brown', 'purple', 'red', 'green', 'pink', 'yellow', 'orange'];
var origin = ['German', 'Japanese', 'Turkish', 'American', 'Asian', 'Canadian', 'Colombian'];
var material = ['metal', 'wooden', 'plastic', 'silver', 'gold', 'cotton', 'paper', 'steel'];
var animal = {
  big: ['elephant', 'bird', 'spider', 'whale', 'hippo', 'giraffe', 'bear'],
  small: ['raccoon', 'bird', 'turtle', 'rabbit', 'frog', 'dove']
};
var objects = ['bag', 'table', 'skirt', 'car', 'castle', 'dress'];

var QuestionGenerator = function () {
  function QuestionGenerator() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, QuestionGenerator);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(QuestionGenerator, null, [{
    key: 'rnd',
    value: function rnd(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    }
  }, {
    key: 'getRandomSizeOf',
    value: function getRandomSizeOf(key) {
      return QuestionGenerator.rnd(size[key]);
    }

    // five huge young black Canadian bears

  }, {
    key: 'setPattern00',
    value: function setPattern00() {
      var numStr = QuestionGenerator.rnd(numeral);
      var unit = numStr === 'one';
      var sizeFlg = new Date().getTime() % 2 === 0;

      return new __WEBPACK_IMPORTED_MODULE_2__model_Question__["a" /* Question */](numStr, // Determiner
      undefined, // Opinion
      QuestionGenerator.getRandomSizeOf(sizeFlg ? 'big' : 'small'), // Size
      undefined, // Shape
      QuestionGenerator.rnd(age.animal), // Age
      QuestionGenerator.rnd(color), // Color
      undefined, // Origin
      undefined, // Material
      QuestionGenerator.rnd(animal[sizeFlg ? 'big' : 'small']) + (unit ? '' : 's') // Noun
      );
    }

    // a beautiful big round clean new red dotted Italian silk shopping bag

  }, {
    key: 'setPattern01',
    value: function setPattern01() {
      var flg = new Date().getTime() % 2 === 0;
      var sizeFlg = new Date().getTime() % 2 === 0;

      return new __WEBPACK_IMPORTED_MODULE_2__model_Question__["a" /* Question */](flg ? 'The' : 'A', // Determiner
      QuestionGenerator.rnd(opinion), // Opinion
      QuestionGenerator.getRandomSizeOf(sizeFlg ? 'big' : 'small'), // Size
      QuestionGenerator.rnd(shape), // Shape
      QuestionGenerator.rnd(age.object), // Age
      QuestionGenerator.rnd(color), // Color
      QuestionGenerator.rnd(origin), // Origin
      QuestionGenerator.rnd(material), // Material
      QuestionGenerator.rnd(objects) // Noun
      );
    }

    // Some delicious Indian cuisine

  }, {
    key: 'setPattern02',
    value: function setPattern02() {
      var flg = new Date().getTime() % 2 === 0;

      return new __WEBPACK_IMPORTED_MODULE_2__model_Question__["a" /* Question */]('Some', // Determiner
      'delicious', // Opinion
      undefined, // Size
      undefined, // Shape
      undefined, // Age
      undefined, // Color
      flg ? 'Indian' : 'Thai', // Origin
      undefined, // Material
      'cuisine' // Noun
      );
    }

    // a beautiful tall thin young Japanese man

  }, {
    key: 'setPattern03',
    value: function setPattern03() {
      var flg = new Date().getTime() % 2 === 0;

      return new __WEBPACK_IMPORTED_MODULE_2__model_Question__["a" /* Question */]('A', // Determiner
      'beautiful', // Opinion
      'tall', // Size
      undefined, // Shape
      'young', // Age
      undefined, // Color
      QuestionGenerator.rnd(origin), // Origin
      undefined, // Material
      flg ? 'man' : 'woman' // Noun
      );
    }

    // a wonderful old Italian clock

  }, {
    key: 'setPattern04',
    value: function setPattern04() {
      return new __WEBPACK_IMPORTED_MODULE_2__model_Question__["a" /* Question */]('A', // Determiner
      'wonderful', // Opinion
      undefined, // Size
      undefined, // Shape
      QuestionGenerator.rnd(age.object), // Age
      undefined, // Color
      QuestionGenerator.rnd(origin), // Origin
      undefined, // Material
      'clock' // Noun
      );
    }
  }, {
    key: 'setTonguetwisters01',
    value: function setTonguetwisters01() {
      var flg = new Date().getTime() % 2 === 0;

      return new __WEBPACK_IMPORTED_MODULE_2__model_Question__["a" /* Question */]('A', // Determiner
      undefined, // Opinion
      'big', // Size
      undefined, // Shape
      undefined, // Age
      'black', // Color
      undefined, // Origin
      undefined, // Material
      flg ? 'bug' : 'bear' // Noun
      );
    }
  }, {
    key: 'getWords',
    value: function getWords() {
      var arr = ['The', 'A'].concat(numeral);
      arr = arr.concat(opinion);
      arr = arr.concat(size.big);
      arr = arr.concat(size.small);
      arr = arr.concat(shape);
      arr = arr.concat(age.animal);
      arr = arr.concat(age.object);
      arr = arr.concat(color);
      arr = arr.concat(origin);
      arr = arr.concat(material);
      arr = arr.concat(animal.big);
      arr = arr.concat(animal.small);
      arr = arr.concat(objects);

      return arr;
    }
  }, {
    key: 'create',
    value: function create() {
      var patternList = [];
      patternList.push(QuestionGenerator.setPattern00);
      patternList.push(QuestionGenerator.setPattern01);
      patternList.push(QuestionGenerator.setPattern02);
      patternList.push(QuestionGenerator.setPattern03);
      patternList.push(QuestionGenerator.setPattern04);
      patternList.push(QuestionGenerator.setTonguetwisters01);
      return QuestionGenerator.rnd(patternList)();
    }
  }]);

  return QuestionGenerator;
}();

/* harmony default export */ __webpack_exports__["a"] = (QuestionGenerator);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

__webpack_require__("uXP9");
__webpack_require__("i1v5");
__webpack_require__("SFaN");
__webpack_require__("5W1q");

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.41fda57b93b0a6e07c27.js